// extracted by mini-css-extract-plugin
module.exports = {"card":"NotEnoughMana_card__2ny6d","paragraph":"NotEnoughMana_paragraph__3z2AB","getMana":"NotEnoughMana_getMana__cMU5U","buttons":"NotEnoughMana_buttons__16ez4"};